import { render } from "./LanguageIcon.vue?vue&type=template&id=d1d17f0e&scoped=true"
import script from "./LanguageIcon.vue?vue&type=script&lang=js"
export * from "./LanguageIcon.vue?vue&type=script&lang=js"

import "./LanguageIcon.vue?vue&type=style&index=0&id=d1d17f0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1d17f0e"]])

export default __exports__